var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "관련 가동전점검 개선사항 목록",
          columns: _vm.grid.columns,
          gridHeight: _vm.setGridHeight,
          data: _vm.moc.prestartupImproves,
          merge: _vm.grid.merge,
          filtering: false,
          columnSetting: false,
          usePaging: false,
          editable: _vm.editable && !_vm.disabled,
        },
        on: { linkClick: _vm.linkClick, innerBtnClicked: _vm.innerBtnClicked },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }